<template>
  <div class="CDK-info" v-if="showing">
    <div @click="_close">
      <modal-mask></modal-mask>
    </div>

    <div class="exchange-info-wrapper" :style="`background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBg'][0]};`">
      <img @click="_close" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['secondaryPopClose'][0]}`" class="modal-close" alt="">
    <header>兑换信息</header>
    <div>兑换码：{{cdk}}</div>
    <div>QQ号：{{qqNum}}</div>
  </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'
import ModalMask from '@/components/modal/ModalMask'

export default {
name: 'CDKInfo',

components: {
  ModalMask
},
computed: {
    ...mapState(['h5ConfigImgPath', 'h5ConfigDetails'])
  },
props: {

},
data () {
  return {
    baseUrl,
    showing: false
  }
},
created () {

},
mounted () {

},
methods: {
  show (cdk, qqNum) {
    this.showing = true
    this.cdk = cdk
    this.qqNum = qqNum
  },
  _close () {
    this.showing = false
  }
}
}
</script>

<style scoped lang="less">
@import '../../style/mixin';

.exchange-info-wrapper{
  width: 29.7rem;
  height: 14.5rem;
  text-align: center;
  background-color: @modal-bg-color;
  .modal-common;
  .modal-anim;
}

.exchange-info-wrapper header {
  font-size: 1.8rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #7E3E1B;
  line-height: 2.6rem;
  margin: 1.7rem 0 2.7rem 0;
  text-align: center;
}
.exchange-info-wrapper div{
  font-size: 1.5rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #A9420B;
  line-height: 1.5rem;
  margin: 0 0 1.8rem 3.7rem;
  text-align: left;
}
</style>
